import ExplorerActions from 'actions/ExplorerActions';
import NavigationActions from 'actions/NavigationActions';
import AuthStore from 'stores/AuthStore';
import Utils from 'util/Utils';
import WebUtils from 'util/WebUtils';
import i18n from 'util/i18n';
import { WL_ACCEPT_STATUS } from 'constants/Finance';

export function doLogout() {
  setTimeout(() => {
    ExplorerActions.logout();
    NavigationActions.goTo({
      pathname: '/auth/cp',
    });
  }, 200);
}

export async function checkToken(onLogout) {
  /* do not reload from payment page */
  if (window.location.href.indexOf('/settings/payment/') !== -1) return;

  const reload = () => {
    let homeUrl = window.location.href;
    homeUrl = homeUrl.substring(0, homeUrl.indexOf('#') + 1);
    homeUrl += '/mob';
    window.location.replace(homeUrl);

    const loggedUserId = localStorage.getItem('userId');

    if (!loggedUserId || loggedUserId === 'null') {
      sessionStorage.removeItem('userId');
    } else {
      sessionStorage.setItem('userId', loggedUserId);
    }

    setTimeout(() => window.location.reload(), 100);
  };

  // console.log(new Date().getTime(), ' >>> AuthStore.isLogged(): ', AuthStore.isLogged(), ', token: ', localStorage.getItem('token'), ', userId: ', sessionStorage.getItem('userId'));

  let userId = sessionStorage.getItem('userId');
  if (userId === 'null') {
    userId = null;
    sessionStorage.removeItem('userId');
  }

  if (!AuthStore.isLogged()) {
    if (!userId) return;
    reload();
  } else if (!userId) {
    reload();
  }

  const contractStatus = AuthStore.getContractStatus();
  if (contractStatus !== WL_ACCEPT_STATUS.ACCEPTED) return;

  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  const token = WebUtils.getCookie('token') || localStorage.getItem('token');
  if (token) {
    headers.append('Authorization', `Bearer ${token}`);
  }

  const restApi = Utils.urlAPI();
  const response = await fetch(`${restApi}/userpublic/checktoken/${userId}`, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  const { valid, otherUser, subAdminRelogin } = json;
  if (!valid) {
    doLogout();
    if (onLogout) {
      onLogout();
    }
  } else if (otherUser) {
    reload();
  } else if (subAdminRelogin) {
    doLogout();
    if (onLogout) {
      onLogout();
    }
    /* eslint-disable no-alert */
    setTimeout(() => alert(i18n.t('cp_partner.partner_user_relogin')), 100);
  }
}
